
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISSMCCMapConfigInterface, ISSMCCMapFollowSpacecraft } from "./issmccmap.types";
import { api } from "../../services/api";
import { IDataTLEs } from "../../services/api.types";

@Component
export default class ISSMCCMapConfigComponent extends Vue {
  @Prop() config!: ISSMCCMapConfigInterface
  AVAILABLE_SPACECRAFT: Array<string> = new Array<string>()

  created() {
    let subscr = api.sendResponse("data/tles", "")
      .subscribe((data: IDataTLEs) => {
        if (data) {
          subscr.unsubscribe()
          this.AVAILABLE_SPACECRAFT = data.tles.map(tle => tle[0].trim())
        }
      })
  }

  get availableSpacecraft(): Array<string> {
    return this.AVAILABLE_SPACECRAFT.concat(this.config.hasOwnProperty("additionalSpacecraft") ? this.config.additionalSpacecraft : [])
      .filter((name) => !name.includes("ISS (ZARYA)"))
  }

  get additionalSpacecraft(): Array<string> {
    return this.config.hasOwnProperty("additionalSpacecraft") && Array.isArray(this.config.additionalSpacecraft) ? this.config.additionalSpacecraft : [];
  }
  set additionalSpacecraft(value: Array<string>) {
    this.config.additionalSpacecraft = value.slice(0, 2);
  }

  get followSpacecraft() {
    if (!this.config.followSpacecraft) {
      Vue.set(this.config, "followSpacecraft", {
        name: "ISS (ZARYA)",
        enabled: false
      })
    }
    return this.config.followSpacecraft
  }
  set followSpacecraft(value: ISSMCCMapFollowSpacecraft) {
    this.config.followSpacecraft = value
  }

  get followSpacecraftEnable() {
    return this.followSpacecraft.enabled;
  }
  set followSpacecraftEnable(value: boolean) {
    this.followSpacecraft = {
      ...this.followSpacecraft,
      enabled: value
    }
  }
  get followSpacecraftAvailable() {
    return ["ISS (ZARYA)"].concat(this.config.hasOwnProperty("additionalSpacecraft") ? this.config.additionalSpacecraft : [])
  }

  get followSpacecraftName() {
    return this.followSpacecraft.hasOwnProperty("name") ? this.followSpacecraft.name : "ISS (ZARYA)";
  }
  set followSpacecraftName(value: string) {
    this.followSpacecraft = {
      ...this.followSpacecraft,
      name: value
    }
  }

  @Watch("config")
  onConfigChange(value: ISSMCCMapConfigInterface) {
    this.$emit("update:config", value);
  }
}
